module.exports = __webpack_public_path__ + "media/components/country-flag/static/eu-510ca6da0d406bf2e66dce7733deff41.svg";